"use strict";

define('service/board',['appkit/service', 'view/board/member.detail'], function (Service, BoardMemberDetailView) {
  var BoardService = Service.extend({
    replies: {
      'build:boardMemberDetail': 'buildBoardMemberDetail'
    },
    buildBoardMemberDetail: function buildBoardMemberDetail(options) {
      options = options || {};
      var events = _.extend({}, Backbone.Events),
        Attribute = this.model('Attribute'),
        BoardMember = this.model('BoardMember'),
        attributes = Attribute.all(),
        member = options.model,
        parent = options.parent,
        content = null;
      if (!(member instanceof BoardMember)) {
        throw new Error('You must call board member detail with a member instance.');
      }
      delete options.parent;
      content = new BoardMemberDetailView(options);
      app.overlay.buttonType = 'done';
      app.overlay.size = 'mini';
      app.overlay.header.text = member.get('person').get('displayName');
      app.overlay.subHeader.text = member.get('membership');
      if (parent) {
        content.listenTo(parent, 'destroy', function () {
          app.overlay.active = false;
        });
      }
      content.listenTo(member.findAttributeValueByName('Membership Status'), 'change:value', function () {
        app.overlay.subHeader.text = member.get('membership');
      }).listenTo(attributes, 'sync', function () {
        attributes.each(function (attr) {
          var attributeValue = member.findAttributeValueByName(attr.get('name'), {
            allowNull: true
          });
          if (attributeValue) {
            attributeValue.get('attribute').get('choices').set(attr.get('choices').models);
            attributeValue.get('attribute').set(attr.pick('id', 'description'));
          }
        });
      }).listenTo(member.get('attributeValues'), 'sync', function () {
        content.state = '';
      }).listenTo(member.get('attributeValues'), 'error', function (model, err, options) {
        content.state = 'error';
        content.errorMessages.collection.reset([{
          text: err instanceof Error ? String(err.message) : String(err)
        }]);
      }).listenTo(app.overlay, 'hidden', function () {
        content.destroy();
        events.trigger('hidden');
        events.off().stopListening();
      });
      _.defer(function () {
        app.overlay.active = true;
      });
      app.overlay.content.show(content);
      attributes.fetch();
      return events;
    }
  });
  return BoardService;
});

